import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Table, Image, Button } from "react-bootstrap";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { NavLink } from "react-router-dom";
import Switch from "react-switch";
import moment from "moment";

function PosLoginReport(props) {
  const RenderTableBody = () => {
    return (
      <React.Fragment>
        <TableBody />
      </React.Fragment>
    );
  };
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Log in Report
                  <br />
                </div>
                <div>
                  <div
                    align="right"
                    style={{ color: "#9E9E9E" }}
                    className="f10-400 my-2"
                  >
                    Report Run Date: {moment().format("Do MMM, YYYY")}
                  </div>
                  <span
                    className="f12-400 text-grey"
                    style={{ color: "#9E9E9E" }}
                  >
                    Report Range Date:
                  </span>
                  <span className="f12-500">
                    {" "}
                    {moment().format("Do MMM, YYYY")} {"-"}{" "}
                    {moment().format("Do MMM, YYYY")}
                  </span>
                </div>
                {/* <div className="col-6 text-right">
                  <NavLink
                    to="/addPos"
                    className="mr-4 px-5 py-2 btn addBtnRed f12-700"
                    style={{ color: "#f26856" }}
                  >
                    + Add new
                  </NavLink>
                </div> */}
              </div>
              <div className="row">
                <div className="col-4  pl-0 d-flex">
                  <Image
                    //   onClick={() =>
                    //     setState({
                    //       ...state,
                    //       showSearch: !state.showSearch,
                    //     })
                    //   }
                    alt="filter"
                    title="filter"
                    width="80px"
                    src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                  />
                  <div
                    className="f10-400"
                    align="center"
                    // onClick={() => showFilter(!filter)}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                      width="80px"
                    />
                    <br />
                  </div>
                  <div
                    className="f10-400"
                    align="center"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    // onClick={props.handleClick}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/sortbtn.svg")}
                      width="80px"
                    />
                    <br />
                  </div>
                  <div className="f10-400" align="center">
                    <img
                      src={require("../../../../assets/images/iconButton/downloadbtn.svg")}
                      width="80px"
                      alt="icon"
                    />
                    <br />
                  </div>
                </div>
                <div className="col-5"></div>
                <div className="col-3 d-flex align-items-center justify-content-end">
                  <div className="mr-3">
                    <SelectFilter onDateChange={() => {}} />
                  </div>
                </div>
              </div>
              <hr />
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                {/* <div className="col-12 p-0 user-table-reusable-superadmin table-responsive"> */}
                <Table className="">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: "15%" }} className="f12-400">
                        Business Name <br />
                        /Location/ID
                      </td>
                      <td style={{ width: "15%" }} className="f12-400">
                        POS
                      </td>
                      <td style={{ width: "15%" }} className="f12-400">
                        Recent Acess
                      </td>
                      <td style={{ width: "20%" }} className="f12-400">
                        Current Status
                      </td>
                    </tr>
                  </thead>
                  {RenderTableBody()}
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const TableBody = (props) => {
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = () => setTrDetail(!TrDetail);
  return (
    <tbody className="w-100 super-admin-all-vendor-main-table-body">
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr className="sd_body_table-row" onClick={showTr}>
                <td style={{ width: "15%" }}>
                  <div className="f12-500"> McDonalds </div>
                  <div className="f10-400">Hadapsar </div>
                  <div className="f10-400 opacity-50">#1245789632 </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f12-500">PetPooja</div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f12-400">
                    23/07/2023
                    <br /> 10:15 AM
                  </div>
                </td>
                <td style={{ width: "20%" }}>
                  <div className="f12-500 greendot d-flex align-items-center">Active</div>
                </td>
                <td style={{ width: "20%" }}>
                  <ul
                    type="none"
                    className={"enStatusList"}
                    style={{ justifyContent: "left" }}
                  >
                    <li style={{ width: "68%", fontSize: "14px" }}>
                      Test Connection
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

export default PosLoginReport;
